import { v4 as uuidv4 } from "uuid";

const list = [
  {
    id: uuidv4(),
    title: "faqQuestion1",
    text: "faqAnswer1",
  },
  {
    id: uuidv4(),
    title: "faqQuestion2",
    text: "faqAnswer2",},
  {
    id: uuidv4(),
    title: "faqQuestion3",
    text: "faqAnswer3",},
  {
    id: uuidv4(),
    title: "faqQuestion4",
    text: "faqAnswer4",},
  {
    id: uuidv4(),
    title: "faqQuestion5",
    text: "faqAnswer5",},
];

export default list;
